import { render } from "./SwitchEdit.vue?vue&type=template&id=2365193e"
import script from "./SwitchEdit.vue?vue&type=script&lang=js"
export * from "./SwitchEdit.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SwitchEdit.vue?vue&type=style&index=0&id=2365193e&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__